'use client';

import * as NiceModal from "@ebay/nice-modal-react";

export const ModalProvider = ({ children }) => {
  return (
    <NiceModal.Provider>
      {children}
    </NiceModal.Provider>
  );
};
